import { ScanStatus } from '@/constants';
import { handleAsyncAction } from '@/utils/handle-async-action';

export const getSuccessfulScan = (scansData, scanId?) => {
  return scansData?.find(({ id, status }) => {
    const isComplete = status === ScanStatus.Complete;
    const isMatch = scanId ? id === scanId : true;
    return isComplete && isMatch;
  });
};

export const handleScanAction = async ({
  scanId,
  scans,
  setLoading,
  setResult,
  fetcher
}) => {
  await handleAsyncAction({
    setLoading,
    setResult,
    fetcher: async () => {
      if (!scanId) return null;

      const completedScan = getSuccessfulScan(scans, scanId);
      if (!completedScan) return null;

      return await fetcher(scanId);
    }
  });
};
